export const medecine360SessionTokenKeyName = "medecine360SessionToken";
export const medecine360SessionQueryParamKeyName = "sessionToken";

export const storeMedecine360SessionToken = (
  urlSearchParam: URLSearchParams
) => {
  const medecine360SessionToken = urlSearchParam.get(
    medecine360SessionQueryParamKeyName
  );
  if (medecine360SessionToken) {
    window.sessionStorage.setItem(
      medecine360SessionTokenKeyName,
      medecine360SessionToken
    );
  }
};
export const getMedecine360SessionTokenFromStorage = () => {
  return (
    window.sessionStorage.getItem(medecine360SessionTokenKeyName) ??
    new URLSearchParams(document.location.search).get(
      medecine360SessionQueryParamKeyName
    )
  );
};
export function removeMedecine360SessionTokenFromStorage() {
  if (window.sessionStorage.getItem(medecine360SessionTokenKeyName)) {
    window.sessionStorage.removeItem(medecine360SessionTokenKeyName);
  }
}

export const isTimeExpires = (expiresAt: Date) => {
  const expirationDate = new Date(expiresAt);

  const now = new Date();
  const timeDifference = expirationDate.getTime() - now.getTime();

  const countDown = Math.floor(timeDifference / 1000);
  return countDown < 0;
};
